import { Box } from '@mui/material';

import OnboardingPopover from '@shared/ui/popovers/OnboardingPopover';

import { OnboardingRocket } from '../OnboardingRocket/OnboardingRocket';

export const OnboardingHeaderSetup = () => {
  return (
    <Box
      mr={{ xs: '8px' }}
      display="flex"
      alignItems="center"
      sx={{
        cursor: 'pointer',
      }}
    >
      <OnboardingPopover>
        <OnboardingRocket />
      </OnboardingPopover>
    </Box>
  );
};
